import { LfClaims, hasPerm, hasRole, parseOrgs } from './lf-claims';

/** The internal Bidscircle pharmacy; the `dev` role on it is the technical profile. */
export const INTERNAL_ANF = '123456';

/**
 * Whether a login-farmacias token lets its holder use "Ver como": `global_admin`, `company_admin:bidscircle`,
 * the organisation role `dev` on the internal ANF 123456, or `bidsweb:operational`. The same rule as
 * `ImpersonationAuthorizer.HasImpersonationRole` in bidscircleapi, which is what decides; this only decides
 * whether the button is shown. A legacy session is not asked: its rule is an internal email and an active profile.
 */
export function ssoMayImpersonate(claims: LfClaims): boolean {
  return (
    hasRole(claims, 'global_admin') ||
    hasRole(claims, 'company_admin:bidscircle') ||
    parseOrgs(claims.orgs).some((o) => o.anf === INTERNAL_ANF && o.roles.includes('dev')) ||
    hasPerm(claims, 'bidsweb:operational')
  );
}
